import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RadnoMesto } from './radno-mesto';
import { BaseDataService, BaseTabsUpdateComponent, ModalService, ModelDataService, TabsContainerService, UserService } from 'yt-ng-framework';

@Component({
  selector: 'yt-radno-mesto-poslovi-tab-update',
  templateUrl: './radno-mesto-poslovi-tab-update.component.html'
})
export class RadnoMestoPosloviTabUpdateComponent 
  extends BaseTabsUpdateComponent<RadnoMesto> 
  implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<RadnoMesto>,
    protected baseDataService: BaseDataService,
    protected userService: UserService,
    protected modalService: ModalService,
    protected modelDataService: ModelDataService,
    protected router: Router
  ) { 
    super(activatedRoute, tabsContainerService, baseDataService, userService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
